import React from 'react';
import WorkspacesColumn from '../../components/ExpandableColumn/WorkspacesColumn';
import RecentColumn from '../../components/ExpandableColumn/RecentColumn';
import StarredColumn from '../../components/ExpandableColumn/StarredColumn';
import NotificationsColumn from '../../components/ExpandableColumn/NotificationsColumn';
import FeedbackColumn from '../../components/ExpandableColumn/FeedbackColumn';
import PagesColumn from '../../components/ExpandableColumn/PagesColumn';

import WorkspaceSidebar from '../../components/Profile/WorkspaceSidebar';
import MyDayColumn from '../../components/ExpandableColumn/MyDayColumn';

const rightPanelContent = {
    navWorkspaces: (props) => <WorkspaceSidebar {...props} />,
    navRecent: (props) => <RecentColumn {...props} />,
    navStarred: (props) => <StarredColumn {...props} />,
    navPages: (props) => <PagesColumn {...props} />,
    notifications: (props) => <NotificationsColumn {...props} />,
    feedBack: (props) => <FeedbackColumn {...props} />,
    myDay: (props) => <MyDayColumn {...props} />,
};

export const getRightPanelContentById = (id, props) => rightPanelContent[id] ? rightPanelContent[id](props) : null;

// Content titles for the right panel header
export const getRightPanelTitle = (contentId) => {
    const titles = {
        navWorkspaces: 'Workspaces',
        navRecent: 'Recent Boards',
        navStarred: 'Starred Boards',
        navPages: 'Pages',
        notifications: 'Notifications',
        feedBack: 'Feedback',
        myDay: 'My Day',
    };
    return titles[contentId] || 'Panel';
};
